import { render, staticRenderFns } from "./org_info.vue?vue&type=template&id=d4526a02&scoped=true"
import script from "./org_info.vue?vue&type=script&lang=js"
export * from "./org_info.vue?vue&type=script&lang=js"
import style0 from "./org_info.vue?vue&type=style&index=0&id=d4526a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4526a02",
  null
  
)

export default component.exports